module.exports = __webpack_public_path__ + "img/sol_cap1.e2d9277d.png";